export default __webpack_public_path__ + "static/media/iconAws.d91f62db.svg";